<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>{{ $t('detailDomiciliationBancaire.domBancaireReglement.title') }}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <v-client-table :data="domiciliationBancaire.domBancaireReglement"
                          :columns="columns"
                          :options="options"
                          ref='tableDomBancaireReglement'>
            <div slot="modeReglement" slot-scope="props">
              {{ getModeReglement(props.row.modeReglementId) }}
            </div>
            <div slot="sens" slot-scope="props">
              {{ props.row.sens === constantes.SENS_VENTE ?
              $t('general.sens.vente') :$t('general.sens.achat') }}
            </div>
          </v-client-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { SENS_VENTE } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    domiciliationBancaire: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        SENS_VENTE,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          modeReglement: this.$t('detailDomiciliationBancaire.domBancaireReglement.tab.libelleMode'),
          sens: this.$t('detailDomiciliationBancaire.domBancaireReglement.tab.sens'),
          libelleEcriture: this.$t('detailDomiciliationBancaire.domBancaireReglement.tab.libelleEcriture'),
          libelleLigneEcritureTiers: this.$t('detailDomiciliationBancaire.domBancaireReglement.tab.libelleEcritureClient'),
          libelleLigneEcritureBanque: this.$t('detailDomiciliationBancaire.domBancaireReglement.tab.libelleEcritureBanque'),
          libelleReferenceTiers: this.$t('detailDomiciliationBancaire.domBancaireReglement.tab.referenceTiers'),
          libelleReferenceBanque: this.$t('detailDomiciliationBancaire.domBancaireReglement.tab.referenceBanque'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {},
        sortable: [],
      };
    },
    columns() {
      return ['modeReglement', 'sens', 'libelleEcriture', 'libelleLigneEcritureTiers', 'libelleLigneEcritureBanque', 'libelleReferenceTiers', 'libelleReferenceBanque'];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getModeReglement(modeReglementId) {
      const modeReglement = this.parametre(PARAMETRES_KEYS.modeReglement).find((mode) => {
        return mode.id === modeReglementId;
      });
      return modeReglement ? modeReglement.libelle : null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
